window.addEventListener('load', function () {
  var header = document.querySelector('header-component');
  if (!header) return;

  header.style.setProperty('background', 'transparent', 'important');

  function onScroll() {
    var pageWrapper = document.querySelector('.page-wrapper');
    var scrollTop = (pageWrapper && pageWrapper.scrollTop > 0)
      ? pageWrapper.scrollTop
      : window.scrollY;

    if (scrollTop > 50) {
      header.style.setProperty('background', 'rgba(245, 216, 152, 0.6)', 'important');
    } else {
      header.style.setProperty('background', 'transparent', 'important');
    }
  }

  // Escuchar en ambos
  var pageWrapper = document.querySelector('.page-wrapper');
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
});
